(function () {
    'use strict';

    angular
        .module('crewing')
        .config(config);

    function config($stateProvider) {
        $stateProvider
            .state('crewing', {
                url: '/crewing/:mode?/:time?',
                views: {
                    'crewingView': {
                        templateUrl: 'crewing/views/crewing.tpl.html',
                        controller: 'CrewingCtrl',
                        controllerAs: 'crewing'
                    }
                },
                onEnter: function(UserPrivilegesService){
                  UserPrivilegesService.setUserPrivilegeView("crewing");
                }
            });
    }
}());
